module.exports = __webpack_public_path__ + "img/trustchain.abaafb6e.png";